<template>
  <v-card class="my-1">
    <v-toolbar flat dense>
      <v-toolbar-title>Zuwendungsbestätigung</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <div class="confirmation-field">
        <div class="d-flex align-center mb-1">
          <v-icon small class="mr-1">{{ mdiCertificateOutline }}</v-icon>
          <span class="text-body-2 font-weight-medium">Bestätigungscode</span>
          <v-tooltip bottom max-width="280">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" x-small class="ml-1">{{ mdiInformationOutline }}</v-icon>
            </template>
            <span>Ab diesem Betrag wird auf dem Spendengerät ein Bestätigungscode für die Anfrage einer Zuwendungsbestätigung angezeigt.</span>
          </v-tooltip>
          <reset-icon :setting="minAmount" @clear="$emit('clear', minAmount.key)" @set-here="$emit('set-here', minAmount.key)" />
        </div>
        <div class="d-flex align-center confirmation-row">
          <v-checkbox
            :input-value="isEnabled"
            @change="toggleEnabled"
            dense
            hide-details
            class="mt-0 pt-0"
          >
            <template #label>
              <span class="text-body-2">Anzeigen ab</span>
            </template>
          </v-checkbox>
          <v-text-field
            v-if="isEnabled"
            type="number"
            :value="minAmount.currentValue"
            @input="val => emitAmount(val)"
            suffix="€"
            outlined
            dense
            hide-details
            class="confirmation-amount"
            autocomplete="off"
          ></v-text-field>
          <span v-else class="text-body-2 text--disabled">Wird nie angezeigt</span>
        </div>
      </div>

      <div v-if="contactEmail" class="confirmation-field mt-4">
        <div class="d-flex align-center mb-1">
          <v-icon small class="mr-1">{{ mdiEmailOutline }}</v-icon>
          <span class="text-body-2 font-weight-medium">Kontaktadresse</span>
          <v-tooltip bottom max-width="280">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" x-small class="ml-1">{{ mdiInformationOutline }}</v-icon>
            </template>
            <span>E-Mail-Adresse, die zusammen mit dem Bestätigungscode auf dem Bildschirm angezeigt wird.</span>
          </v-tooltip>
          <reset-icon :setting="contactEmail" @clear="$emit('clear', contactEmail.key)" @set-here="$emit('set-here', contactEmail.key)" />
        </div>
        <v-text-field
          :id="'id-'+contactEmail.key"
          type="email"
          :value="contactEmail.currentValue"
          @input="val => $emit('input', { key: contactEmail.key, value: val && val.trim() !== '' ? val : null })"
          outlined
          dense
          hide-details="auto"
          :rules="emailRules"
          autocomplete="off"
        ></v-text-field>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiInformationOutline, mdiCertificateOutline, mdiEmailOutline } from '@mdi/js'
import ResetIcon from '@/components/device/ResetIcon'

export default {
  name: 'ConfirmationGroup',
  components: { ResetIcon },
  props: {
    minAmount: {
      type: Object,
      required: true,
    },
    contactEmail: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      mdiInformationOutline,
      mdiCertificateOutline,
      mdiEmailOutline,
      emailRules: [
        (v) => (!v || (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Gültige E-Mail-Adresse eingeben'))
      ],
      // Remembers the last set amount so re-enabling after "Wird nie angezeigt"
      // doesn't lose the previous threshold.
      lastAmount: this.minAmount.currentValue >= 0 ? this.minAmount.currentValue : (this.minAmount.defaultValue ?? 300),
    }
  },
  computed: {
    isEnabled () {
      return this.minAmount.currentValue >= 0
    },
  },
  watch: {
    'minAmount.currentValue' (newVal) {
      if (newVal >= 0) {
        this.lastAmount = newVal
      }
    },
  },
  methods: {
    emitAmount (rawValue) {
      let value = parseInt(rawValue)
      if (isNaN(value) || value < 0) {
        value = 0
      }
      this.lastAmount = value
      this.$emit('input', { key: this.minAmount.key, value })
    },
    toggleEnabled (checked) {
      if (checked) {
        this.$emit('input', { key: this.minAmount.key, value: this.lastAmount })
      } else {
        if (this.minAmount.currentValue >= 0) {
          this.lastAmount = this.minAmount.currentValue
        }
        this.$emit('input', { key: this.minAmount.key, value: -1 })
      }
    },
  },
}
</script>

<style scoped>
.confirmation-row {
  gap: 12px;
}
.confirmation-amount {
  max-width: 120px;
}
</style>
